// @core/api/endpoints/platform/list_platform_members.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPlatformMembersResponse,
} from '../../../types/platform';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/platform';

/**
 * List platform members
 * Returns a paginated list of all platform members. Supports filtering by role and membership status.
 */
export async function ListPlatformMembers(
  platform_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPlatformMembersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/members`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<ListPlatformMembersResponse>(requestPath, { ...requestOptions, params });
}
